import { Form } from "react-bootstrap";

interface DropdownProps {
  label: string;
  name: string;
  tabIndex?: number;
  options: string[];
  required?: boolean;
  value?: string;
  onChange?: any;
  onBlur?: any;
  isValid?: any;
  isInvalid?: any;
  errorFeedback?: any;
  disabled?: boolean;
}

export const DropdownMenu: React.FC<DropdownProps> = ({
  label,
  name,
  tabIndex,
  options,
  required = false,
  value,
  onChange,
  onBlur,
  isValid,
  isInvalid,
  errorFeedback,
  disabled = false,
}) => {
  return (
    <Form.Group controlId={name}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        as="select"
        name={name}
        tabIndex={tabIndex}
        required={required}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isValid={isValid}
        isInvalid={isInvalid}
        disabled={disabled}
      >
        <option key="" value={""}>
          Choose
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Form.Control>
      <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
    </Form.Group>
  );
};
